import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { ApiCore } from 'src/app/config/api';
import { JwtService } from '../auth/jwt.service';
import { SessionService } from '../auth/session.service';

@Injectable({
  providedIn: 'root',
})
export class SocketInactivityService {
  private socket!: Socket;

  constructor(
    private readonly jwt: JwtService,
    private readonly session: SessionService
  ) {}

  public startSocket() {
    this.socket = io(ApiCore.BASE_URL + 'inactivity');
    this.socket.connect();
    this.setupListeners();

    this.socket.on('connect', () => {
      const userId = this.jwt.getData(
        this.session.getItem('token') || '',
        'id'
      );

      this.socket.emit('userIdConnect', { userId });
    });

    localStorage.setItem('lang', 'cacsa');
  }

  private setupListeners() {
    this.socket.on('disconnect', (reason: string) => {
      if (reason === 'ping timeout') {
        //no se manneja de esta forma, por que el socket se desconectaba varias veces o no mandaba el ping interval inicial
        // y provocaba que se cerrara la sesion
        //incorrectamente
        // console.log('SESIÓN CERRADA POR INACTIVIDAD');
        // this.socket.disconnect();
      }
    });

    // this.socket.on('ping', () => {
    //   console.log('Ping recibido, enviando Pong');
    //   this.socket.emit('pong'); // Responder al ping del servidor
    // });

    this.socket.on('ping', (callback) => {
      callback(true);
    });

    this.socket.on('Timestamp', (callback) => {
      callback(parseInt(this.session.getItem('lastActivityTimestamp') || '0'));
    });
  }

  public stopSocket() {
    this.socket?.disconnect();
  }
}
